import { AbstractControl, ValidationErrors } from '@angular/forms';

export function integerValidator(control: AbstractControl): ValidationErrors | null {
  if (control.value === null) {
    return null;
  }

  return !Number.isInteger(control.value) ? { integer: { actual: control.value } } : null;
}
